import { Box, makeStyles, Typography } from "@material-ui/core";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import { observer } from "mobx-react";
import { useState } from "react";
import { useStore } from "@roc/client-portal-shared/hooks";
import { FileUploadModal, FileUpload } from "@roc/ui";

const useStyles = makeStyles(() => ({
  card: {
    width: "208px",
    height: "170px",
    border: "2px dashed #427ED1",
    borderRadius: 16,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gridGap: "8px",
    cursor: "pointer",
    color: "#427ED1",
    backgroundColor: "#EAF4FA",
  },
}));


interface AddPhotosCardProps {
  inspectionId: number;
  inspectionTaskId: number;
}

export const AddPhotosCard = observer(({ inspectionId, inspectionTaskId }: AddPhotosCardProps) => {
  const classes = useStyles();
  const { inspectionStore } = useStore();
  const { inspectionPhotosStore } = inspectionStore;
  const [open, setOpen] = useState(false);

  const handleUpload = async (uploads: FileUpload[]) => {
    for (const upload of uploads) {
      await inspectionPhotosStore.uploadManualPhoto(inspectionId, inspectionTaskId, upload.file);
    }
  };

  return (
    <>
      <Box className={classes.card} onClick={() => setOpen(true)}>
        <AddPhotoAlternateIcon style={{ fontSize: 32 }} />
        <Typography variant="body2">Add Photos</Typography>
      </Box>
      <FileUploadModal
        title="Add Photos"
        open={open}
        multiple
        fileTypes={['jpg', 'jpeg', 'png']}
        onClose={() => setOpen(false)}
        onUpload={handleUpload}
      />
    </>
  );
});
